import { useGoogleLogin } from '@react-oauth/google';

interface GoogleLoginButtonProps {
  onSuccess: (userData: { email: string; name: string; googleId: string }) => void;
  onError?: () => void;
  label?: string;
  className?: string;
  disabled?: boolean;
}

export default function GoogleLoginButton({
  onSuccess,
  onError,
  label = 'Continuar com Google',
  className = '',
  disabled = false,
}: GoogleLoginButtonProps) {
  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        // Use the access token to fetch user profile from Google
        const res = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        });

        if (!res.ok) throw new Error('Failed to fetch Google user info');

        const profile = await res.json();
        onSuccess({
          email: profile.email,
          name: profile.name,
          googleId: profile.sub,
        });
      } catch {
        onError?.();
      }
    },
    onError: () => {
      onError?.();
    },
  });

  return (
    <button
      type="button"
      onClick={() => login()}
      disabled={disabled}
      className={[
        'w-full inline-flex items-center justify-center gap-2 rounded-xl px-4 py-3',
        'text-[0.95rem] font-semibold',
        'border border-[#334155] bg-[#0f172a] text-[#f1f5f9]',
        'hover:bg-white/5 transition-colors',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        className,
      ].join(' ')}
    >
      {/* Google multicolor icon */}
      <svg className="w-5 h-5" viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"
          fill="#4285F4"
        />
        <path
          d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
          fill="#34A853"
        />
        <path
          d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
          fill="#FBBC05"
        />
        <path
          d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
          fill="#EA4335"
        />
      </svg>
      {label}
    </button>
  );
}
